// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__M5Pdu","closeIcon":"Modal_closeIcon__tM410","modal":"Modal_modal__muTf8","hide":"Modal_hide__QZLUl"};